import { useEffect, useState } from 'react';
import { Button, Container } from '@mui/material';
import { toast } from 'react-toastify';
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Loader from '../../components/Loader';
import { DeliveryTimeSlotConfig } from '../../client/services';
import DeliverySlotsCalendarDialog from './DeliverySlotsCalendarDialog';
import DeliverySlotExceptions from './DeliverySlotExceptions';
import Iconify from '../../components/Iconify';

const DeliveryTimeSlotsPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState('[]');
  const [calendarRefreshKey, setCalendarRefreshKey] = useState(0);
  const [calendarOpen, setCalendarOpen] = useState(false);

  const loadData = async () => {
    setIsLoading(true);
    try {
      const current = await DeliveryTimeSlotConfig.find({
        query: { current: true },
      });
      setValue(current?.value || '[]');
    } catch (error: any) {
      toast.error(error?.message || 'Failed to load delivery time slots');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Page title='Delivery Time Slots'>
      <Container
        maxWidth='xl'
        sx={{ minWidth: 0, px: { xs: 1.5, sm: 2, md: 3 } }}
      >
        <HeaderBreadcrumbs
          heading='Delivery Time Slots'
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Delivery Time Slots' },
          ]}
          action={
            <Button
              variant='contained'
              startIcon={<Iconify icon='mdi:calendar-month' />}
              onClick={() => setCalendarOpen(true)}
              sx={{
                whiteSpace: 'nowrap',
                justifyContent: 'center',
              }}
            >
              View Capacity Calendar
            </Button>
          }
        />

        {isLoading ? (
          <Loader />
        ) : (
          <DeliverySlotExceptions
            defaultSlotsJson={value}
            onSaved={() => setCalendarRefreshKey((prev) => prev + 1)}
          />
        )}

        <DeliverySlotsCalendarDialog
          open={calendarOpen}
          onClose={() => setCalendarOpen(false)}
          refreshKey={calendarRefreshKey}
        />
      </Container>
    </Page>
  );
};

export default DeliveryTimeSlotsPage;
